<template>
  <b-row>
    <b-col cols="12" xl="12">
      <transition name="slide">
      <b-card :header="caption">
        <div style="text-align:right;margin:0px 0px 10px 0px">

        </div>
        <b-row>    
          <b-col cols="4" xl="4">
            <b-form inline>
                <label class="mr-sm-2" for="inlineInput1">Limit: </label>
                <b-form-select id="limit"
                  :plain="true"
                  v-model="limit"
                  :options="[10,25,50,100]">
                </b-form-select>
            </b-form>
          </b-col>    
          <b-col cols="4" xl="4">

          </b-col>

          <b-col cols="3" xl="3">
            <b-form-input type="text" id="search" placeholder="Search.." v-model="q" ></b-form-input>
          </b-col>
        </b-row>
        <br/>
        
        <b-alert :variant="msg_type"
              v-if="msg"
              dismissible
              :show="msg!=''"
              @dismissed="msg=''">
            {{msg}}
        </b-alert>
        <div class="table-responsive">
        <table v-if="!isLoading"  aria-busy="false" aria-colcount="5" class="table b-table table-striped table-hover">
            <thead class="">
                <tr>
                    <th aria-colindex="1" class="">#</th>
                    <th aria-colindex="2" class="">Category</th>
                    <th aria-colindex="6" class="" width="150px"></th>
                </tr>
            </thead>
            <!---->
            <tbody class="">
              <tr v-for="(item,index) in items" >
                <td>{{getNumber(index)}}</td>
                <td>{{item.name}}</td>
                <td>
                  <b-button size="sm" variant="info" class="btn-sm" @click="selectImage(item)" v-b-tooltip.hover title="Select">
                    Select
                  </b-button>
                </td>
              </tr>
            </tbody>
        </table>
        </div>
        <square v-if="isLoading"></square>
        
        <nav>
          <b-pagination size="sm" :total-rows="totalRows" :per-page="limit" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card>
      </transition>
    </b-col>
   
  </b-row>
</template>

<script>

//import usersData from './UsersData'
//import usersData from './UsersData'
export default {
  name: 'CategoryModal',
  mounted() {
    this.getCategory().then((e)=>{

    })
    this.msg = this.$route.query.msg;
    this.msg_type = this.$route.query.msg_type;
  },
  props: {
    caption: {
      type: String,
      default: 'CategoryModal'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      fields: [
        {key: 'id'},
        {key: 'name'},
        {key: 'image'},
        {key: 'date'},
      ],
      currentPage: 1,
      totalRows: 0,
      limit:10,
      category:'',
      options:{
        category:[]
      },
      q:'',
      deleteModal:false,
      publishModal:false,
      isLoading:true,
      id:'',
      order:'',
      msg:'',
      msg_type:'',
    }
  },
  computed: {
  },
  watch: {

  },
  methods: {
    selectImage(item){
      item.type_h = 'headline_category';
      this.$emit('select', item);
    },
    async getCategory(){
      var app = this;
      var url = this.end_point+'content_category';
      app.isLoading = true;
      axios.get(url, {})
        .then(function (resp) {
        app.isLoading=false;
        console.log(resp)
        if(resp.data.error){
          app.$notify.error(resp.data.msg);
        }else{
          app.items = resp.data.data;
        }
      })
      .catch(function (resp) {
        console.log(resp);
        app.isLoading=false;
        // app.$notify.error(app.setting.msg_con);
        app.error = true;
      });  
    },
    getNumber(index){
      return (parseInt(index)+1) +((parseInt(this.currentPage)-1) *parseInt(this.limit));
    },
    getBadge (status) {
      return status ===  null ? 'success': 'danger'
    },
    getRowCount (items) {
      return items.length
    },
    userAdd(){
      this.$router.push({path: 'content/add'});
    },
    userEdit(id){
      this.$router.push({path: `content/edit/${id}`});
    },
    userDelete(id){
      this.deleteModal = true;
      this.id = id;
    },
    userView(item){
      var url = this.setting.base_url+item.link;
      window.open(url,'_blank');
    },
    deleteAction(){
      var app = this;
      var url = this.end_point+'content/'+this.id;
      axios.delete(url, {})
      .then(function (resp) {
        console.log(resp);
        
          app.error = false;
          app.$notify.success(resp.data.msg);
          app.getDatas(1);
      })
      .catch(function (resp) {
          app.$notify.error(app.setting.msg_con);
          app.error = true;
      });
    },
    publishAction(){
      var app = this;
      var url = this.end_point+'content/'+this.id;
      axios.put(url, {status:'publish'})
      .then(function (resp) {
        
          app.error = false;
          app.$notify.success(resp.data.msg);
          app.getDatas(1);
      })
      .catch(function (resp) {
          app.$notify.error(app.setting.msg_con);
          app.error = true;
      });
    },
    deleteAction(){
      var app = this;
      var url = this.end_point+'content/'+this.id;
      axios.delete(url, {})
      .then(function (resp) {
        console.log(resp);
        
          app.error = false;
          app.$notify.success(resp.data.msg);
          app.getDatas(1);
      })
      .catch(function (resp) {
          app.$notify.error(app.setting.msg_con);
          app.error = true;
      });
    },
    onChange(){
    },
    getDatas(page,limit='10',q='',order='a.name ASC'){
      var app = this;
      if (typeof page === 'undefined') {
            page = 1;
      }
      
      this.isLoading = true;
      axios.get(this.end_point+'content?q='+q+'&page='+page+'&limit='+limit+'&order='+order+'&category='+this.category)
      .then(function (resp) {
        app.isLoading = false;
          if(resp.data.error){          
            app.$notify.error('Could not load data ');

            return false;
          }
          //console.log(resp.data.rows);
          app.currentPage = page;
          app.items = resp.data.data;
          //app.items.push(...resp.data.rows);
          app.totalRows = resp.data.total;
      })
      .catch(function (resp) {
          app.isLoading = false;
          //console.log(resp);
          app.$notify.error('Could not load data ');
      });
    },
    alert(pesan) {
      this.$notify.error('Could not load data ');
    },

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
